<template>
  <div class="manual-step">
    <div class="manual-step__number">
      <img
        class="manual-step__img"
        src="~@/assets/img/manual/step-bg.png"
        alt=""
      />
      {{ number }}
    </div>
    <div class="manual-step__text"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "ManualStep",
  props: {
    number: Number
  }
};
</script>

<style lang="scss">
.manual-step {
  width: 246px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 25px 50px;

  &__number {
    position: relative;
    z-index: 1;
    width: 156px;
    height: 156px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: "Montserrat";
    font-weight: bold;
    font-size: 90px;
    line-height: 110px;

    color: #fbc33e;

    margin-bottom: 30px;
  }

  &__img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    pointer-events: none;
  }

  &__text {
    font-family: "Montserrat";
    font-weight: bold;
    font-size: 30px;
    line-height: 37px;
    text-align: center;
  }
}
</style>
